import React from 'react';
import SingleButton from './SingleButton';
import { red } from '@mui/material/colors';
import DeleteIcon from '@mui/icons-material/Delete';

function DeleteButton({ dialogMessage, onClickDelete, disabled }) {
  return (
    <SingleButton
      variant="contained"
      bgColor={red[800]}
      textColor="#fff"
      hoverColor={red[700]}
      isDeleteButton
      icon={<DeleteIcon sx={{ color: 'white' }} />}
      dialogMessage={dialogMessage}
      onClick={onClickDelete}
      disabled={disabled}
    >
      Excluir
    </SingleButton>
  );
}

export default DeleteButton;
